import React from "react";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";
import { Money } from "@Shared/Components/Money/Money";
import { SubItem } from "./SubItem";
import messages from "../messages";

export const OtherExpenses = ({ linkedExpenses }) => {
  return (
    <SubItem title={<FormattedMessage {...messages["otherExpenses"]} />}>
      {linkedExpenses.map((expense, index) => (
        <SubItem
          key={index}
          title={expense?.description}
          price={
            <Money
              cents={expense?.amountCents}
              currency={expense?.amountCurrency}
            />
          }
          nested
        />
      ))}
    </SubItem>
  );
};
